<div class="auth-desktop-layout min-h-screen bg-white">

  <!-- Panel izquierdo: mismo hero que el login -->
  <div class="relative hidden w-1/2 overflow-hidden bg-[#0F0F3D] md:flex">
    <img src="assets/images/fondo-main.svg" alt="" class="absolute inset-0 h-full w-full object-cover" />
    <img src="assets/images/fondo 1.svg" alt=""
      class="absolute inset-0 h-full w-full object-cover mix-blend-screen opacity-100" />

    <div class="relative z-10 flex h-full w-full flex-col justify-between px-6 py-8 lg:pl-20 lg:pr-12 lg:py-12">
      <div>
        <img src="assets/images/ardia.svg" alt="ARDIA" class="h-7 brightness-0 invert lg:h-10" />
      </div>

      <div class="flex flex-1 items-center">
        <h1
          class="text-3xl font-extrabold leading-[1.15] tracking-tight text-white md:text-4xl lg:text-[3.2rem] xl:text-[3.5rem]"
          style="text-shadow: 0 1px 8px rgba(0,0,0,0.18);">
          La plataforma de<br>
          <span class="text-[#60A5FA]">Agentes<br>Inteligentes</span>,<br>
          conectada a los<br>
          datos de tu<br>
          empresa en<br>
          tiempo real.
        </h1>
      </div>

      <div class="flex w-full items-center gap-4">
        <div class="h-px flex-1 bg-white/30"></div>
        <p class="whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.3em] text-white/80">Inteligencia
          artificial para empresas</p>
        <div class="h-px flex-1 bg-white/30"></div>
      </div>
    </div>
  </div>

  <!-- Panel derecho: aviso -->
  <div class="flex w-full items-center justify-center px-6 py-10 md:w-1/2 bg-[#F9FAFB]">
    <div class="w-full max-w-[480px]">
      <img src="assets/images/ardia.svg" alt="ARDIA" class="h-7 mb-8 md:hidden" />

      <div class="rounded-2xl border border-[#E5E7EB] bg-white p-8 sm:p-10 shadow-sm" role="alert">
        <div class="w-14 h-14 rounded-xl bg-[var(--color-error-400)] flex items-center justify-center mb-6">
          <fa-icon [icon]="faBan" class="text-2xl text-[var(--color-error-700)]"></fa-icon>
        </div>

        <h2 class="text-2xl font-bold leading-tight text-[var(--color-text-400)] mb-4">{{ title }}</h2>

        <p class="text-[15px] leading-relaxed text-[#374151] mb-4">{{ message }}</p>

        <p class="text-sm text-[#6B7280] mb-8">Si crees que es un error, contacta con el soporte de ARDIA.</p>

        <button
          type="button"
          (click)="backToLogin()"
          class="w-full py-3 text-sm font-semibold text-white bg-[var(--color-brand-400)] rounded-lg hover:bg-[var(--color-brand-500)] transition-colors cursor-pointer">
          Volver al inicio de sesión
        </button>
      </div>
    </div>
  </div>
</div>
